import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { AsyncPaginate } from 'react-select-async-paginate';
import axios from 'axios';
import moment from 'moment';
import { URL } from '../../../redux/common/url';
import { adminAction } from '../../../redux/common/action';
import { getAllbookingsAction } from '../../../redux/Admin/action';
import { Button, Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

interface Option {
  value: string;
  label: string;
}

interface PaginatedResponse {
  results: Option[];
  has_more: boolean;
}

interface Value {
  id: string;
  name: string;
}

function ExpiredBooking() {
  const [sortingField, setSortingField] = useState('');
  const [sortingOrder, setSortingOrder] = useState('asc');
  const [totalItems, setTotalItems] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(1);
  const [itemsPerPage, setitemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [sorting, setSorting] = useState({ field: '', order: '' });
  const [criId, setcriId] = useState<any>('');

  const dispatch = useDispatch();
  const [pageNo, setpageNo] = useState<any>(1);
  const [circles, setCircles] = useState<Value[]>([]);
  const [managerKey, setManagerKey] = useState<any>(0);
  const [managerKeyAen, setManagerKeyAen] = useState<any>(0);
  const [seleceteMangerXen, setseleceteMangerXen] = useState<any>({});
  const [seleceteMangerAen, setseleceteMangerAen] = useState<any>({});
  const [seleceteMangerJen, setseleceteMangerJen] = useState<any>({});
  const [selectedSource, setSelectedSource] = useState<any>({});

  // date filter
  const [name, setName] = useState<string>('');
  const [toDate, setToDate] = useState<string>('');
  const [fromDate, setFromDate] = useState<string>('');

  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState<any>(null);
  const [startDate, setStartDate] = useState(new Date());
  const [totalDistance, setTotalDistance] = useState<string>('');
  const [selectedVehicle, setSelectedVehicle] = useState<any>({});
  const [selectedDestination, setSelectedDestination] = useState<any>({});

  const get_product_list: any = useSelector((state: any) =>
    state.admin.get_all_booking ? state.admin.get_all_booking : {}
  );

  const ITEMS_PER_PAGE = 10;
  const comments = get_product_list?.data ? get_product_list?.data : [];

  const headers = [
    { name: 'S.No.', field: '_id', sortable: false },
    { name: 'Booking Id', field: 'id', sortable: false },
    { name: 'Customer Name', field: 'customer', sortable: false },
    { name: 'Number', field: 'number', sortable: false },
    { name: 'Vehicle', field: 'vehicle', sortable: false },
    { name: 'Booked By/Date Time', field: 'booked', sortable: false },
    { name: 'Pickup Location', field: 'location', sortable: false },
    { name: 'Drop Location', field: 'drop', sortable: false },
    { name: 'Pickup Date Time', field: 'time', sortable: false },
    { name: 'Reason', field: 'reason', sortable: false },
    { name: 'Driver', field: 'driver', sortable: false },
    { name: 'Driver status', field: 'driver_status', sortable: false },
    { name: 'Status', field: 'status', sortable: false },
    { name: 'Action', field: 'action', sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (sorting.field) {
      const reversed = sorting.order === 'asc' ? 1 : -1;
      computedComments = computedComments.sort(
        (a: any, b: any) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting]);

  const handlePageClick = (event: any) => {
    const data = event?.selected + 1;
    setpageNo(data);
    getCancelData(data);
    return () => { };
  };

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setPageCount(Math.ceil(get_product_list?.total / itemsPerPage));
  }, [itemOffset, itemsPerPage, comments]);

  const onSortingChange = (field: any) => {
    const order = field === sortingField && sortingOrder === 'asc' ? 'desc' : 'asc';
    setSortingField(field);
    setSortingOrder(order);
    setSorting({ field, order });
  };

  const [cecleId, setcecleId] = useState<any>({});

  useEffect(() => {
    fetchCircles();
  }, []);

  const fetchCircles = async () => {
    try {
      const response: any = await axios.get(`${URL.API_BASE_URL + URL.getAllCircles}`);
      if (response?.data?.data) {
        setCircles(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(adminAction.circleList({}));
    return () => { };
  }, []);

  const calculateDistance = () => {
    if (!selectedSource?.latitude || !selectedDestination?.latitude) return;

    const startCoords = {
      latitude: selectedSource.latitude,
      longitude: selectedSource.longitude,
    };
    const endCoords = {
      latitude: selectedDestination.latitude,
      longitude: selectedDestination.longitude,
    };

    const R = 6371; // Radius of the Earth in kilometers
    const lat1 = toRadians(startCoords.latitude);
    const lon1 = toRadians(startCoords.longitude);
    const lat2 = toRadians(endCoords.latitude);
    const lon2 = toRadians(endCoords.longitude);

    const dLat = lat2 - lat1;
    const dLon = lon2 - lon1;

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c;

    setTotalDistance(distance.toFixed(1));
    console.log(`Distance: ${distance} kilometers`);
  };

  const toRadians = (degrees: any) => {
    return (degrees * Math.PI) / 180;
  };

  useEffect(() => {
    if (selectedSource.value && selectedDestination.value) {
      calculateDistance();
    }
  }, [selectedSource, selectedDestination]);

  const loadOptionsRole = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');
    const prfix = `/api/${JSON.parse(token)?.data?.prefix}`;
    const response = await fetch(
      URL.API_BASE_URL +
      prfix +
      `/get_all_user_circle?search=${search}&page=${page}&circle_id=${cecleId}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token).api_token}`,
        },
      }
    );

    const responseJSON: PaginatedResponse = await response.json();
    const options: any = responseJSON?.results?.map((data: any) => {
      data.value = data?.id;
      data.label = data?.name;
      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: page + 1,
      },
    };
  };

  const [managerKeyJen, setManagerKeyJen] = useState<any>(0);

  useEffect(() => {
    if (criId) {
      loadOptionsgetManagerXen('', [], { page: 1 });
      loadOptionsgetManagerAen('', [], { page: 1 });
      loadOptionsgetManagerJenAnother('', [], { page: 1 });
      setManagerKey((prevKey: any) => prevKey + 1);
      setManagerKeyAen((prevKey: any) => prevKey + 1);
      setManagerKeyJen((prevKey: any) => prevKey + 1);
      setseleceteMangerXen({});
      setseleceteMangerAen({});
      setseleceteMangerJen({});
    }
  }, [criId]);

  useEffect(() => {
    if (seleceteMangerXen?.id) {
      loadOptionsgetManagerAen('', [], { page: 1 });
      loadOptionsgetManagerJenAnother('', [], { page: 1 });
      setManagerKeyAen((prevKey: any) => prevKey + 1);
      setManagerKeyJen((prevKey: any) => prevKey + 1);
      setseleceteMangerAen({});
      setseleceteMangerJen({});
    }
  }, [seleceteMangerXen]);

  useEffect(() => {
    if (seleceteMangerAen?.id) {
      loadOptionsgetManagerJenAnother('', [], { page: 1 });
      setManagerKeyJen((prevKey: any) => prevKey + 1);
      setseleceteMangerJen({});
    }
  }, [seleceteMangerAen]);

  useEffect(() => {
    dispatch(adminAction.getgetAllCircles(''));
    return () => { };
  }, []);

  const loadOptionsgetManagerXen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');
    const response = await fetch(
      URL.API_BASE_URL + `/api/admins/get_all_xen?search=${search}&page=${page}&circle_id=${criId}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token).api_token}`,
        },
      }
    );

    const responseJSON: PaginatedResponse = await response.json();
    const options: any = responseJSON?.results?.map((data: any) => {
      data.value = data?.id;
      data.label = data?.name;
      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsgetManagerAen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');
    const response = await fetch(
      URL.API_BASE_URL +
      `/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerXen?.id}&circle_id=${criId}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token).api_token}`,
        },
      }
    );

    const responseJSON: PaginatedResponse = await response.json();
    const options: any = responseJSON?.results?.map((data: any) => {
      data.value = data?.id;
      data.label = data?.name;
      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: page + 1,
      },
    };
  };

  const loadOptionsgetManagerJenAnother = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');
    const response = await fetch(
      URL.API_BASE_URL +
      `/api/admins/get_department_child?search=${search}&page=${page}&id=${seleceteMangerAen?.id}&circle_id=${criId}`,
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(token).api_token}`,
        },
      }
    );

    const responseJSON: PaginatedResponse = await response.json();
    const options: any = responseJSON?.results?.map((data: any) => {
      data.value = data?.id;
      data.label = data?.name;
      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: page + 1,
      },
    };
  };

  useEffect(() => {
    if (seleceteMangerJen?.id || criId || seleceteMangerXen?.id || seleceteMangerAen?.id) {
      const finaId = seleceteMangerJen?.id
        ? seleceteMangerJen?.id
        : seleceteMangerAen?.id
          ? seleceteMangerAen?.id
          : seleceteMangerXen?.id
            ? seleceteMangerXen?.id
            : criId;
      const type = seleceteMangerJen?.id
        ? 'jen'
        : seleceteMangerAen?.id
          ? 'Aen'
          : seleceteMangerXen?.id
            ? 'Xen'
            : 'ca';
      dispatch(adminAction.getExpiredBookingsallfilter({ page: pageNo, id: finaId, type: type }));
    } else {
      getCancelData(pageNo);
    }
  }, [currentPage, seleceteMangerJen?.id, criId, seleceteMangerAen?.id, seleceteMangerXen?.id]);

  const getCancelData = (page: any) => {
    const query = [
      `page=${page}`,
      fromDate && `fromdate=${moment(fromDate).format('YYYY-MM-DD')}`,
      toDate && `todate=${moment(toDate).format('YYYY-MM-DD')}`,
      name && `search=${name}`,
    ].filter(Boolean).join('&');
    dispatch(adminAction.getExpiredBookingsall({ query }));
  };

  const colorPicker = (e: any) => {
    let color = 'white';
    switch (e) {
      case 'Pending':
        color = '#7ABAEB';
        break;
      case 'Going-To-FillingStation':
        color = '#F4E778';
        break;
      case 'Accepted':
        color = '#AFDDF4';
        break;
      case 'Arrived-To-FillingStation':
        color = '#A995CD';
        break;
      case 'Going-To-Destination':
        color = '#E8B86D';
        break;
      case 'Arrived-To-Destination':
        color = '#A1D6B2';
        break;
      case 'Filling-Started':
        color = '#BF2EF0';
        break;
      case 'otp-pending':
        color = '#F6EACB';
        break;
      case 'Completed':
        color = '#97BE5A';
        break;
      case 'Cancel':
        color = '#FFAAAA';
        break;
      case 'Expired':
        color = '#ff6060';
        break;
      default:
        color = 'white';
    }
    return color;
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const nextDay = new Date(today);
  nextDay.setDate(nextDay.getDate() + 1);



  const handleEditClick = (booking: any) => {
    setSelectedBooking(booking);
    setStartDate(new Date(booking.date));
    setSelectedSource({
      value: booking.source_hydrant_center?.id,
      label: booking.source_hydrant_center?.address,
      latitude: booking.source_hydrant_center?.latitude,
      longitude: booking.source_hydrant_center?.longitude,
    });
    setSelectedVehicle({
      value: booking.vehicle?.id,
      label: booking.vehicle?.registration_number,
    });
    setSelectedDestination({
      value: booking.destination?.id,
      label: booking.destination?.address,
      latitude: booking.destination?.latitude,
      longitude: booking.destination?.longitude,
    });
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleStartDateChange = (date: any) => {
    setStartDate(date);
  };

  const loadOptionsgetManagerJen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');
    const prfix = `/api/admins`;
    const jen_id = selectedBooking?.user?.jen_id || JSON.parse(token)?.data?.id;
    const response = await fetch(
      `${URL.API_BASE_URL}${prfix}/getSource?search=${search}&page=${page}&jen_id=${jen_id}`,
      {
        headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` },
      }
    );
    const responseJSON: PaginatedResponse = await response.json();
    const options = responseJSON?.results?.map((data: any) => ({
      value: data?.id,
      label: data?.station_name || data?.address,
      latitude: data?.latitude,
      longitude: data?.longitude,
      ...data,
    }));
    return { options, hasMore: responseJSON.has_more, additional: { page: page + 1 } };
  };

  const loadOptionsgetManagerVehicle = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const token: any = await localStorage.getItem('kt-auth-react-v');
    const prfix = `/api/admins`;
    const jen_id = selectedBooking?.user?.jen_id || JSON.parse(token)?.data?.id;
    const response = await fetch(
      `${URL.API_BASE_URL}${prfix}/all_vehicle_jen?search=${search}&page=${page}&jen_id=${jen_id}`,
      {
        headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` },
      }
    );
    const responseJSON: PaginatedResponse = await response.json();
    const options = responseJSON?.results?.map((data: any) => ({
      value: data?.id,
      label: data?.registration_number,
      ...data,
    }));
    return { options, hasMore: responseJSON.has_more, additional: { page: page + 1 } };
  };

  const loadOptionsgetManagerUser = async (search: any, loadedOptions: any, { page }: { page: any }) => {
    const prfix = `/api/admins`;
    const token: any = await localStorage.getItem('kt-auth-react-v');
    const user_id = selectedBooking?.user_id;
    const response = await fetch(
      `${URL.API_BASE_URL}${prfix}/user_destinations?search=${search}&page=${page}&user_id=${user_id}`,
      {
        headers: { Authorization: `Bearer ${JSON.parse(token).api_token}` },
      }
    );
    const responseJSON: PaginatedResponse = await response.json();
    const options = responseJSON?.results?.map((data: any) => ({
      value: data?.id,
      label: data?.address,
      latitude: data?.latitude,
      longitude: data?.longitude,
      ...data,
    }));
    return { options, hasMore: responseJSON.has_more, additional: { page: page + 1 } };
  };

  const handleSubmit = async () => {
    if (!selectedSource?.value) return toast.error('Please select a source');
    if (!selectedVehicle?.value) return toast.error('Please select a vehicle');
    if (!selectedDestination?.value) return toast.error('Please select a destination');

    const payload = {
      booking_id: selectedBooking?.id,
      source_hydrant_center: parseInt(selectedSource.value),
      vehicle: parseInt(selectedVehicle.value),
      date: moment(startDate).format('YYYY/MM/DD hh:mm A'),
      destination: parseInt(selectedDestination.value),
      total_distance: totalDistance,
    };

    try {
      const token: any = await localStorage.getItem('kt-auth-react-v');
      const response = await axios.post(`${URL.API_BASE_URL}/api/admins/completeExpireBooking`, payload, {
        headers: {
          Authorization: `Bearer ${JSON.parse(token).api_token}`,
        },
      });
      if (response.status === 200) {
        toast.success('Booking updated successfully');
        handleCloseEditModal();
        getCancelData(pageNo); // Refresh data
      }
    } catch (error: any) {
      toast.error(`Failed to update booking: ${error.response?.data?.message || error.message}`);
    }
  };

  return (
    <div>
      <div className='d-flex flex-column flex-column-fluid'>
        <div id='kt_app_content' className='flex-column-fluid app-content'>
          <div id='' className=' '>
            <div className='card card-flush'>
              <div className='row'>
                <div className='col-3'>
                  <div className='p-5'>
                    <label className='form-label mb-2 fw-semibold fs-6'>
                      <span>Search</span>
                    </label>
                    <input
                      type='search'
                      placeholder='Search wise Name'
                      className='form-control'
                      onChange={(e: any) => setName(e.target.value)}
                    />
                  </div>
                </div>
                <div className='col-3'>
                  <div className='p-5'>
                    <label className='form-label mb-2 fw-semibold fs-6'>
                      <span>Date From</span>
                    </label>
                    <input
                      className='form-control'
                      type='date'
                      onChange={(e: any) => setFromDate(e.target.value)}
                    />
                  </div>
                </div>
                <div className='col-3'>
                  <div className='p-5'>
                    <label className='form-label mb-2 fw-semibold fs-6'>
                      <span>Date To</span>
                    </label>
                    <input
                      className='form-control'
                      type='date'
                      onChange={(e: any) => setToDate(e.target.value)}
                    />
                  </div>
                </div>
                <div className='col-3'>
                  <div className='p-5'>
                    <div
                      className='mt-8'
                      style={{
                        backgroundColor: '#52A841',
                        color: 'white',
                        height: '30px',
                        width: '250px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                      onClick={() => getCancelData(pageNo)}
                    >
                      View
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-3'>
                  <div className='p-5'>
                    <label className='form-label mb-2 fw-semibold fs-6'>
                      <span className='required'>Circle</span>
                    </label>
                    <select
                      className='bg-transparent form-control'
                      aria-label='Select example'
                      name='circle_id'
                      onChange={(e: any) => {
                        setcriId(e?.target?.value);
                        setseleceteMangerXen({});
                        setseleceteMangerAen({});
                        setseleceteMangerJen({});
                      }}
                    >
                      <option value={''}>Select Circle</option>
                      {circles?.map((data, i) => (
                        <option value={data?.id} key={i}>
                          {data?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className='col-3'>
                  <div className='p-5'>
                    <label className='form-label mb-2 fw-semibold fs-6'>
                      <span className='required'>Select Xen</span>
                      <i
                        className='ms-2 fas fa-exclamation-circle fs-7'
                        data-bs-toggle='popover'
                        data-bs-trigger='hover'
                        data-bs-html='true'
                        data-bs-content='Permission names is required to be unique.'
                      ></i>
                    </label>
                    <AsyncPaginate<any, any, any>
                      key={managerKey}
                      value={seleceteMangerXen}
                      loadOptions={loadOptionsgetManagerXen}
                      onChange={(e: any) => {
                        setseleceteMangerXen(e);
                        setseleceteMangerAen({});
                        setseleceteMangerJen({});
                      }}
                      additional={{ page: 1 }}
                      className='bg-transparent form-control'
                    />
                  </div>
                </div>
                <div className='col-3'>
                  <div className='p-5'>
                    <label className='form-label mb-2 fw-semibold fs-6'>
                      <span className='required'>Select Aen</span>
                      <i
                        className='ms-2 fas fa-exclamation-circle fs-7'
                        data-bs-toggle='popover'
                        data-bs-trigger='hover'
                        data-bs-html='true'
                        data-bs-content='Permission names is required to be unique.'
                      ></i>
                    </label>
                    <AsyncPaginate<any, any, any>
                      key={managerKeyAen}
                      value={seleceteMangerAen}
                      loadOptions={loadOptionsgetManagerAen}
                      onChange={(e: any) => {
                        setseleceteMangerAen(e);
                        setseleceteMangerJen({});
                      }}
                      additional={{ page: 1 }}
                      className='bg-transparent form-control'
                    />
                  </div>
                </div>
                <div className='col-3'>
                  <div className='p-5'>
                    <label className='form-label mb-2 fw-semibold fs-6'>
                      <span className='required'>Select Jen</span>
                      <i
                        className='ms-2 fas fa-exclamation-circle fs-7'
                        data-bs-toggle='popover'
                        data-bs-trigger='hover'
                        data-bs-html='true'
                        data-bs-content='Permission names is required to be unique.'
                      ></i>
                    </label>
                    <AsyncPaginate<any, any, any>
                      key={managerKeyJen}
                      value={seleceteMangerJen}
                      loadOptions={loadOptionsgetManagerJenAnother}
                      onChange={setseleceteMangerJen}
                      additional={{ page: 1 }}
                      className='bg-transparent form-control'
                    />
                  </div>
                </div>
              </div>
              <div className='pt-0 card-body'>
                <table className='table table-row-dashed mb-0 align-middle fs-6 gy-5' id='kt_permissions_table'>
                  <thead>
                    <tr>
                      {headers.map((data: any, i: any) => (
                        <th
                          key={i}
                          onClick={() => (data?.sortable ? onSortingChange(data?.field) : null)}
                        >
                          {data?.name}
                          {sortingField && sortingField === data?.field &&
                            (sortingOrder === 'asc' ? (
                              <i className='fa-arrow-down fa-solid'></i>
                            ) : (
                              <i className='fa-arrow-alt-up fas'></i>
                            ))}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className='fw-semibold tbcolor'>
                    {commentsData?.map((data: any, i: any) => {
                      const So = 1 + i;
                      const pgt1 = pageNo - 1;
                      const pgt = pgt1 * 10;
                      const soNo = pgt + So;

                      return (
                        <tr key={i} style={{ backgroundColor: `${colorPicker(data?.status)}` }}>
                          <td>{soNo}</td>
                          <td>{data?.id}</td>
                          <td>{data?.user?.name}</td>
                          <td>{data?.user?.mobile}</td>
                          <td>{data?.vehicle?.registration_number}</td>
                          <td>{moment(data?.date).format('DD-MM-yyyy hh:mm:ss A')}</td>
                          <td>{data?.source_hydrant_center?.address}</td>
                          <td>{data?.destination?.address}</td>
                          <td>{data?.accepted_time
                            ? moment(data?.accepted_time).format('DD-MM-yyyy hh:mm:ss A')
                            : '--'}</td>
                          <td>{data?.reject_reason}</td>
                          <td>{data?.driver?.name}</td>
                          <td><p>{data?.driver_status}</p></td>
                          <td><p>{data?.status}</p></td>
                          <td>
                            <button
                              className='btn btn-sm btn-primary'
                              onClick={() => handleEditClick(data)}
                              style={{
                                cursor: 'pointer',
                                backgroundColor: '#007bff',
                                border: 'none',
                                color: 'white',
                                borderRadius: '5px',
                                padding: '5px 10px',
                                fontSize: '10px',
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                              }}
                            >
                              Edit
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  {get_product_list?.totalDocs == '0' && (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '400px',
                      }}
                    >
                      <h3>Record Not found</h3>
                    </div>
                  )}
                </table>
                <ReactPaginate
                  breakLabel='...'
                  nextLabel='next'
                  className='dataTables_paginate paging_simple_numbers category'
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={2}
                  pageCount={pageCount}
                  previousLabel='previous'
                />
              </div>
            </div>
            <div className='modal fade' id='kt_modal_add_permission' tabIndex={-1} aria-hidden='true'>
              <div className='mw-650px modal-dialog modal-dialog-centered'>
                <div className='modal-content'>
                  <div className='modal-header'>
                    <h2 className='fw-bold'>Add a Permission</h2>
                    <div
                      className='btn btn-icon btn-sm btn-active-icon-primary'
                      data-kt-permissions-modal-action='close'
                    >
                      <span className='svg-icon svg-icon-1'>
                        <svg
                          width='24'
                          height='24'
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <rect
                            opacity='0.5'
                            x='6'
                            y='17.3137'
                            width='16'
                            height='2'
                            rx='1'
                            transform='rotate(-45 6 17.3137)'
                            fill='currentColor'
                          />
                          <rect
                            x='7.41422'
                            y='6'
                            width='16'
                            height='2'
                            rx='1'
                            transform='rotate(45 7.41422 6)'
                            fill='currentColor'
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className='mx-5 mx-xl-15 my-7 scroll-y modal-body'>
                    <form id='kt_modal_add_permission_form' className='form' action='#'>
                      <div className='mb-7 fv-row'>
                        <label className='form-label mb-2 fw-semibold fs-6'>
                          <span className='required'>Permission Name</span>
                          <i
                            className='ms-2 fas fa-exclamation-circle fs-7'
                            data-bs-toggle='popover'
                            data-bs-trigger='hover'
                            data-bs-html='true'
                            data-bs-content='Permission names is required to be unique.'
                          ></i>
                        </label>
                        <input
                          className='form-control form-control-solid'
                          placeholder='Enter a permission name'
                          name='permission_name'
                        />
                      </div>
                      <div className='mb-7 fv-row'>
                        <label className='form-check form-check-custom form-check-solid me-9'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            value=''
                            name='permissions_core'
                            id='kt_permissions_core'
                          />
                          <span className='form-check-label'>
                            Set as core permission
                          </span>
                        </label>
                      </div>
                      <div className='text-gray-600'>
                        Permission set as a <strong className='me-1'>Core Permission</strong> will be
                        locked and <strong className='me-1'>not editable</strong> in future
                      </div>
                      <div className='pt-15 text-center'>
                        <button
                          type='reset'
                          className='me-3 btn btn-light'
                          data-kt-permissions-modal-action='cancel'
                        >
                          Discard
                        </button>
                        <button
                          type='submit'
                          className='btn btn-primary'
                          data-kt-permissions-modal-action='submit'
                        >
                          <span className='indicator-label'>Submit</span>
                          <span className='indicator-progress'>
                            Please wait...
                            <span className='ms-2 spinner-border spinner-border-sm align-middle'></span>
                          </span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className='modal fade' id='kt_modal_update_permission' tabIndex={-1} aria-hidden='true'>
              <div className='mw-650px modal-dialog modal-dialog-centered'>
                <div className='modal-content'>
                  <div className='modal-header'>
                    <h2 className='fw-bold'>Update Permission</h2>
                    <div
                      className='btn btn-icon btn-sm btn-active-icon-primary'
                      data-kt-permissions-modal-action='close'
                    >
                      <span className='svg-icon svg-icon-1'>
                        <svg
                          width='24'
                          height='24'
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <rect
                            opacity='0.5'
                            x='6'
                            y='17.3137'
                            width='16'
                            height='2'
                            rx='1'
                            transform='rotate(-45 6 17.3137)'
                            fill='currentColor'
                          />
                          <rect
                            x='7.41422'
                            y='6'
                            width='16'
                            height='2'
                            rx='1'
                            transform='rotate(45 7.41422 6)'
                            fill='currentColor'
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className='mx-5 mx-xl-15 my-7 scroll-y modal-body'>
                    <div className='d-flex bg-light-warning mb-9 p-6 border border-warning border-dashed rounded notice'>
                      <span className='me-4 svg-icon svg-icon-2tx svg-icon-warning'>
                        <svg
                          width='24'
                          height='24'
                          viewBox='0 0 24 24'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <rect
                            opacity='0.3'
                            x='2'
                            y='2'
                            width='20'
                            height='20'
                            rx='10'
                            fill='currentColor'
                          />
                          <rect
                            x='11'
                            y='14'
                            width='7'
                            height='2'
                            rx='1'
                            transform='rotate(-90 11 14)'
                            fill='currentColor'
                          />
                          <rect
                            x='11'
                            y='17'
                            width='2'
                            height='2'
                            rx='1'
                            transform='rotate(-90 11 17)'
                            fill='currentColor'
                          />
                        </svg>
                      </span>
                      <div className='d-flex flex-grow-1 flex-stack'>
                        <div className='fw-semibold'>
                          <div className='text-gray-700 fs-6'>
                            <strong className='me-1'>Warning!</strong>By editing the permission
                            name, you might break the system permissions functionality. Please
                            ensure you're absolutely certain before proceeding.
                          </div>
                        </div>
                      </div>
                    </div>
                    <form id='kt_modal_update_permission_form' className='form' action='#'>
                      <div className='mb-7 fv-row'>
                        <label className='form-label mb-2 fw-semibold fs-6'>
                          <span className='required'>Permission Name</span>
                          <i
                            className='ms-2 fas fa-exclamation-circle fs-7'
                            data-bs-toggle='popover'
                            data-bs-trigger='hover'
                            data-bs-html='true'
                            data-bs-content='Permission names is required to be unique.'
                          ></i>
                        </label>
                        <input
                          className='form-control form-control-solid'
                          placeholder='Enter a permission name'
                          name='permission_name'
                        />
                      </div>
                      <div className='pt-15 text-center'>
                        <button
                          type='reset'
                          className='me-3 btn btn-light'
                          data-kt-permissions-modal-action='cancel'
                        >
                          Discard
                        </button>
                        <button
                          type='submit'
                          className='btn btn-primary'
                          data-kt-permissions-modal-action='submit'
                        >
                          <span className='indicator-label'>Submit</span>
                          <span className='indicator-progress'>
                            Please wait...
                            <span className='ms-2 spinner-border spinner-border-sm align-middle'></span>
                          </span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showEditModal} onHide={handleCloseEditModal}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='mb-7 fv-row col-12'>
              <div className='p-1'>
                <label className='form-label mb-2 fw-semibold fs-6'>
                  <span className='required'>Customer Name</span>
                </label>
                <input
                  className='form-control form-control-solid'
                  value={selectedBooking?.user?.name || ''}
                  disabled
                />
              </div>
              <div className='p-1'>
                <label className='form-label mb-2 fw-semibold fs-6'>
                  <span className='required'>Mobile Number</span>
                </label>
                <input
                  className='form-control form-control-solid'
                  value={selectedBooking?.user?.mobile || ''}
                  disabled
                />
              </div>
              <div className='p-1'>
                <label className='form-label mb-2 fw-semibold fs-6'>
                  <span className='required'>Select Date</span>
                </label>
                <DatePicker
                  selected={startDate}
                  onChange={handleStartDateChange}
                  // minDate={today}
                  // maxDate={nextDay}
                  showTimeSelect
                  className='form-control bg-transparent'
                  dateFormat='MMMM d, yyyy h:mm aa'
                  placeholderText='Select today or next day'
                />
              </div>
              <div className='p-1'>
                <label className='form-label mb-2 fw-semibold fs-6'>
                  <span className='required'>Source</span>
                </label>
                <AsyncPaginate
                  key={managerKeyJen}
                  value={selectedSource}
                  loadOptions={loadOptionsgetManagerJen}
                  onChange={(option: Option) => setSelectedSource(option)}
                  additional={{ page: 1 }}
                  className='bg-transparent form-control'
                />
              </div>
              <div className='p-1'>
                <label className='form-label mb-2 fw-semibold fs-6'>
                  <span className='required'>Vehicle</span>
                </label>
                <AsyncPaginate
                  key={managerKeyJen + 1}
                  value={selectedVehicle}
                  loadOptions={loadOptionsgetManagerVehicle}
                  onChange={(option: Option) => setSelectedVehicle(option)}
                  additional={{ page: 1 }}
                  className='bg-transparent form-control'
                />
              </div>
              <div className='p-1'>
                <label className='form-label mb-2 fw-semibold fs-6'>
                  <span className='required'>Destination</span>
                </label>
                <AsyncPaginate
                  key={managerKeyJen + 2}
                  value={selectedDestination}
                  loadOptions={loadOptionsgetManagerUser}
                  onChange={(option: Option) => setSelectedDestination(option)}
                  additional={{ page: 1 }}
                  className='bg-transparent form-control'
                />
              </div>
              <div className='p-1'>
                <label className='form-label mb-2 fw-semibold fs-6'>
                  <span>Total Distance</span>
                </label>
                <input
                  className='form-control form-control-solid'
                  value={totalDistance || ''}
                  disabled
                />
              </div>
            </div>
          </div>
          <div className='pt-15 text-center'>
            <Button variant='light' className='me-3' onClick={handleCloseEditModal}>
              Discard
            </Button>
            <Button variant='primary' onClick={handleSubmit}>
              <span className='indicator-label'>Submit</span>
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ExpiredBooking;